import { Box, Container, Link as MuiLink, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { Link as RouterLink } from 'react-router-dom';
import { BrandLogo } from '@/components/BrandLogo';

const footerGroups = [
  {
    title: 'Product',
    links: [
      { label: 'Onboarding', to: '/#onboarding' },
      { label: 'Value', to: '/#value' },
      { label: 'Testimonials', to: '/#testimonials' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { label: 'Privacy Policy', to: '/privacy-policy' },
      { label: 'Terms and Condition', to: '/terms-and-condition' },
    ],
  },
];

export function AppFooter() {
  return (
    <Box
      component="footer"
      sx={(theme) => ({
        borderTop: 1,
        borderColor: 'divider',
        bgcolor: theme.palette.mode === 'light' ? 'background.paper' : alpha(theme.palette.primary.main, 0.1),
        py: { xs: 4, md: 5 },
      })}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: '1.3fr repeat(2, minmax(150px, 0.4fr))' },
            gap: { xs: 3, md: 5 },
          }}
        >
          <Stack spacing={1.5} sx={{ maxWidth: 420 }}>
            <BrandLogo compact markSize={34} />
            <Typography color="text.secondary">
              Cloud-based hospitality management for hotels, guest houses, lodges, and short-stay properties.
            </Typography>
            <Typography variant="caption" color="text.secondary">
              © {new Date().getFullYear()} Nang Book. All rights reserved.
            </Typography>
          </Stack>

          {footerGroups.map((group) => (
            <Stack key={group.title} spacing={1}>
              <Typography variant="body2" sx={{ fontWeight: 900 }}>
                {group.title}
              </Typography>
              {group.links.map((link) => (
                <MuiLink
                  key={link.to}
                  component={RouterLink}
                  to={link.to}
                  color="text.secondary"
                  underline="hover"
                >
                  {link.label}
                </MuiLink>
              ))}
            </Stack>
          ))}
        </Box>
      </Container>
    </Box>
  );
}
